import React from 'react'
import { action, observable } from 'mobx'
import BaseStore from '@store/table'
import Api from '@api/live'
import { message, Modal } from 'hljd'

const confirm = Modal.confirm
class Store extends BaseStore {
  @observable adid = undefined
  @observable price = ''
  @observable visible = false
  @observable liveBalance = ''
  @observable liveProtocol = ''
  @observable buyInfo = []

  getLiveBuyInfo = async () => {
    const {
      data: { liveBalance, liveProtocol, buyInfo = [] },
      success
    } = await Api.liveBuyInfo()

    if (success) {
      this.liveBalance = liveBalance
      this.liveProtocol = liveProtocol
      this.buyInfo = buyInfo
      /*buyInfo.forEach((item, index) => {
        if (index == 1) {
          this.price = item.price
          this.adid = item.adid + ''
        }
      })*/
    }
  }

  @action
  recharge = () => {
    // const { success } = await Api.rechargePay({ adid: this.adid })
    // if (success) {
    let num = this.adid
    let title = '直播账户充值'
    let apiName = '/p/wedding/index.php/admin/APILiveBuyInfo/pay'
    const return_url = '/localMerchant/liveManage'
    let payType = '2'
    window.location.href = `#/localMerchant/cashier?payType=${payType}&price=${
      this.price
    }&title=${title}&apiName=${apiName}&return_url=${return_url}&payParams={"adid":"${num}"}`
    // }
  }

  @action
  showModal = () => {
    confirm({
      title: (
        <p>
          感谢您使用在线充值服务，请您阅读并确认
          <a onClick={this.operateModal}>《婚礼纪视频直播软件服务协议》</a>
        </p>
      ),
      iconType: null,
      onOk: () => {
        this.recharge()
      }
    })
  }

  @action
  operateModal = () => {
    this.visible = !this.visible
  }

  @action
  changeParams = value => {
    this.adid = value
    this.buyInfo.forEach(item => {
      return item.adid == value ? (this.price = item.price) : ''
    })
  }

  @action
  rechargeValidate = liveProtocol => () => {
    if (this.adid && this.price) {
      liveProtocol ? this.showModal() : this.recharge()
    } else {
      message.error('请选择充值金额')
    }
  }
}
export default new Store()
